import { render, staticRenderFns } from "./SlackIntegrationCard.vue?vue&type=template&id=67cfd37d&"
import script from "./SlackIntegrationCard.vue?vue&type=script&lang=js&"
export * from "./SlackIntegrationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports